import React from "react";
import { InfoIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useProduct } from "~/contexts/product-context";
import { useProductAvailability } from "~/hooks/use-product-availability";

import { useFeatureFlags } from "~/contexts/feature-flag-context";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "~/components/ui/tooltip";
import { Text } from "~/components/text";
import { DetailsInfo } from "./details/details-info";

interface ProductSummaryProps {
  title: string;
  authors: string[];
  isbn: string;
  productGroupDescription: string;
}

export const ProductSummary: React.FC<ProductSummaryProps> = ({
  title,
  authors,
  isbn,
  productGroupDescription,
}) => {
  const { t } = useTranslation("productDetails");
  const { product } = useProduct();
  const { features } = useFeatureFlags();
  const { isProductActive } = useProductAvailability();

  const isActive = isProductActive(product?.supplyDetails);
  return (
    <div className="space-y-3">
      <Text as="div" variant="displaySmall" className="flex items-center gap-2">
        {title}
        {!isActive && features.inactiveBooksFilter && (
          <Tooltip>
            <TooltipTrigger>
              <InfoIcon
                className="h-6 w-6 text-system-error"
                aria-label={t("productDetails:productSummary.statusTooltip")}
                data-testid="product-inactive-icon"
              />
            </TooltipTrigger>
            <TooltipContent side="bottom">
              <Text variant="body">
                {t("productDetails:productSummary.statusTooltip")}
              </Text>
            </TooltipContent>
          </Tooltip>
        )}
      </Text>
      <DetailsInfo
        authors={authors}
        productGroupDescription={productGroupDescription}
        isbn={isbn}
      />
    </div>
  );
};
